<template>
  <!-- MBR066/MBR067 VenueDetail — no mockup, follows member_app_UI/song_fa_members_bookings_mobile -->
  <div
    class="page-header align-items-start min-vh-100 mbr-venue"
    v-if="!isConfirmPayment"
  >
    <span class="mask bg-white"></span>
    <div class="container p-0" v-if="isLoadDone">
      <header class="mbr-venue__bar">
        <button
          type="button"
          class="mbr-venue__back"
          :aria-label="$t('common.back')"
          @click="checkTermsConditions ? goToTimeSlot() : goToBooking()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <h1 class="mbr-venue__title">{{ venue.name }}</h1>
      </header>

      <main class="mbr-venue__body">
        <!-- MBR066 terms step -->
        <template v-if="checkTermsConditions">
          <section class="mbr-venue__summary">
            <p class="mbr-venue__eyebrow mbr-venue__eyebrow--peach">{{ $t('venue.your_booking') }}</p>
            <p class="mbr-venue__summary-date">{{ formatDate(timeSlotSelect.date) }}</p>
            <p class="mbr-venue__summary-time">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              {{ timeSlotSelect.time }}
            </p>
          </section>

          <section class="mbr-venue__card">
            <p class="mbr-venue__eyebrow">{{ $t('venue.terms') }}</p>
            <div class="mbr-venue__img">
              <img :src="venue.image" :alt="venue.name" />
            </div>
            <div v-html="venue.terms_conditions" class="mbr-venue__terms c-terms-conditions"></div>
          </section>
        </template>

        <!-- MBR066 type selection -->
        <template v-else>
          <div class="mbr-venue__img mbr-venue__img--hero">
            <img :src="venue.image" :alt="venue.name" />
          </div>

          <section>
            <p class="mbr-venue__eyebrow">{{ $t('venue.select_type') }}</p>
            <div v-if="venue.types.length" class="mbr-venue__grid">
              <button
                v-for="(type, index) in venue.types"
                :key="index"
                type="button"
                class="mbr-venue__type"
                :class="{ 'mbr-venue__type--on': typeSelect.id == type.id }"
                @click="selectType(type)"
              >
                <span class="mbr-venue__type-name">{{ type.name }}</span>
                <span class="mbr-venue__type-price">{{ type.price_format }}</span>
              </button>
            </div>
            <div v-else class="mbr-venue__empty">{{ $t('venue.no_types') }}</div>
          </section>

          <!-- MBR067 date + time slots -->
          <template v-if="typeSelect.id">
            <section>
              <p class="mbr-venue__eyebrow">{{ $t('venue.select_date') }}</p>
              <div class="mbr-venue__date">
                <Datepicker
                  v-model="dateSelect"
                  :enableTimePicker="false"
                  :locale="dateLocale()"
                  class="date-time venue-date-time"
                  :format="format"
                  :minDate="minDate"
                  :maxDate="maxDate"
                  :inline="{ input: true }"
                  text-input
                  auto-apply
                />
              </div>
            </section>

            <section>
              <p class="mbr-venue__eyebrow">{{ $t('venue.select_time') }}</p>
              <div v-if="timeSlot.length" class="mbr-venue__grid">
                <button
                  v-for="(item, index) in timeSlot"
                  :key="index"
                  type="button"
                  class="mbr-venue__slot"
                  :class="{
                    'mbr-venue__slot--on': timeSlotSelect.id == item.id,
                    'mbr-venue__slot--off': !item.status,
                  }"
                  :disabled="!item.status"
                  @click="item.status ? selectTimeSlot(item) : null"
                >
                  <span>{{ item.time_text }}</span>
                  <span v-if="!item.status" class="mbr-venue__slot-note">{{ $t('venue.not_available') }}</span>
                </button>
              </div>
              <div v-else class="mbr-venue__empty">{{ $t('venue.no_slots') }}</div>
            </section>
          </template>
        </template>
      </main>

      <!-- MBR067 sticky CTA: same Next / Continue actions -->
      <div class="mbr-venue__ctabar">
        <div class="mbr-venue__ctabar-inner">
          <button
            v-if="checkTermsConditions"
            type="button"
            class="mbr-venue__cta"
            @click="processBooking()"
          >
            <span>{{ $t('common.continue') }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-6-6 6 6-6 6" />
            </svg>
          </button>
          <button
            v-else
            type="button"
            class="mbr-venue__cta"
            :disabled="!timeSlotSelect.id"
            @click="bookThisVenue()"
          >
            <span>{{ $t('common.next') }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-6-6 6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
  <div v-else>
    <ConfirmPayment
      :typeSelect="typeSelect"
      :timeSlotSelect="timeSlotSelect"
      @back-terms-conditions="backTermsConditions()"
    ></ConfirmPayment>
  </div>
</template>

<script>
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import BookingService from "../services/booking.service";
import Datepicker from "@vuepic/vue-datepicker";
import ConfirmPayment from "@/components/BookingConfirmPayment.vue";
import moment from "moment";
import { getMerchantCode } from "@/config/utils";
import { isEnglish, formatDate as formatLocaleDate, dateLocale } from "@/i18n";
import { mapMutations } from "vuex";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "venue-detail",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    Datepicker,
    ConfirmPayment,
  },
  data() {
    return {
      isLoadDone: false,
      merchantCode: "",
      loaderActive: false,
      snackbar: "",
      message: "",
      dateSelect: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
      venueId: this.$route.params.id ?? 0,
      venue: {},
      branchIdSelect: this.$route.query.branch_id ?? 0,
      typeSelect: {},
      timeSlot: [],
      timeSlotSelect: {},
      checkTermsConditions: false,
      isConfirmPayment: false,
      interval: null,
    };
  },
  async created() {
    this.showLoader();
    await this.venueDetail();
    this.getTimeSlot();
  },
  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";

      this.interval = setInterval(() => {
        if (!this.checkTermsConditions && this.typeSelect.id) {
          this.getTimeSlot(true);
        }
      }, 15000);
  },
  // draws its own header like the design: hide the top navbar (same as Booking)
  beforeMount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.add("mbr-sidenav-overlay");
    app.classList.remove("g-sidenav-pinned");
  },
  beforeUnmount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.remove("mbr-sidenav-overlay");
    if (window.innerWidth > 1200) {
      app.classList.add("g-sidenav-pinned");
    }
  },
  unmounted() {
    clearInterval(this.interval);
  },
  methods: {
    dateLocale,
    ...mapMutations(["toggleNavbarOnly", "toggleHideConfig"]),

    goToBooking() {
      this.$router.push(this.merchantCode + "/booking?branch_id=" + this.branchIdSelect);
    },

    backTermsConditions() {
      this.isConfirmPayment = false;
    },

    bookThisVenue() {
      this.checkTermsConditions = true;
    },

    goToTimeSlot() {
      this.checkTermsConditions = false;
      this.getTimeSlot(true);
      setTimeout(() => {
        this.selectType(this.typeSelect);
      }, 100);
    },

    formatDate(date) {
      if (!isEnglish()) {
        return formatLocaleDate(moment(date).toDate(), { weekday: "long", day: "numeric", month: "long", year: "numeric" });
      }
      return moment(date).format("dddd, D MMMM YYYY");
    },

    selectType(type) {
      this.typeSelect = type;
      // MBR124: the kept slot must carry the new type's price, or a paid type books as free
      if (this.timeSlotSelect.id) {
        this.timeSlotSelect = { ...this.timeSlotSelect, price: type.price };
      }
    },

    selectTimeSlot(slot) {
      this.timeSlotSelect = {
        id: slot.id,
        time: slot.time_text,
        price: this.typeSelect.price,
        date: this.dateSelect,
      };
    },

    format(date) {
      const getDay = String(date.getDate());
      const day = getDay.padStart(2, "0");
      const getMonth = String(date.getMonth() + 1);
      const month = getMonth.padStart(2, "0");
      const year = String(date.getFullYear());
      return `${day}-${month}-${year}`;
    },

    async venueDetail() {
      this.isLoadDone = false;
      var dataForm = {
        venue_id: this.venueId,
        branch_id: this.branchIdSelect,
      };

      await BookingService.venueDetail(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.venue = response.data.data;
            this.maxDate.setTime(this.maxDate.getTime() + (this.venue.max_advance_time * 24 * 60 * 60 * 1000));
            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
        },
        (error) => {
          console.log(error);
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.setTimeOutNotification();
        }
      );
    },

    // MBR124: a refresh (15s poll, back from terms) keeps the picked slot while it is still bookable
    getTimeSlot(isRefresh = false) {
      if (!isRefresh) {
        this.showLoader();
      }
      const dateSelect = this.dateSelect;
      var dataForm = {
        venue_id: this.venueId,
        date_select: dateSelect,
        branch_id: this.branchIdSelect,
      };

      BookingService.getListTimeSlot(dataForm).then(
        (response) => {
          // the date changed while this request was in flight: the newer request owns the list
          if (dateSelect !== this.dateSelect) {
            return;
          }
          if (response.data.result.isSuccess) {
            this.timeSlot = response.data.data;
            if (isRefresh && this.timeSlotSelect.id) {
              const slot = this.timeSlot.find((item) => item.id == this.timeSlotSelect.id);
              if (!slot || !slot.status) {
                this.timeSlotSelect = {};
                this.snackbar = "danger";
                this.message = this.$t("venue.slot_taken");
                this.setTimeOutNotification();
              }
            } else {
              this.timeSlotSelect = {};
            }
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    processBooking() {
      if (this.timeSlotSelect.price == 0) {
        var dataForm = {
          venue_id: this.venueId,
          venue_type_id: this.typeSelect.id,
          slot_id: this.timeSlotSelect.id,
          date_select: this.dateSelect,
          branch_id: this.branchIdSelect,
        };

        BookingService.assignTimeSlotFreeToMember(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              let bookingCode = response.data.data;
              this.$router.push(
                this.merchantCode + "/booking-completed/" + bookingCode
              );
            } else {
              this.snackbar = "danger";
              this.message = errorMessage(response.data.result.message);
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = errorMessage(error);
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      } else {
        this.isConfirmPayment = true;
      }
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    dateSelect(val) {
      if (val) {
        this.getTimeSlot();
      }
    },
  },
};
</script>
<style scoped>
/* MBR066 VenueDetail */
.mbr-venue.page-header {
  overflow: visible;
  overflow-x: clip;
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

/* custom.css still carries the legacy `* { font-family: Poppins }` */
.mbr-venue :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-venue .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-venue .container {
  max-width: 440px;
  margin: 0 auto;
}

.mbr-venue__bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px 12px;
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  border-bottom: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-venue__back {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  color: var(--mbr-color-primary);
  transition: transform 0.15s ease;
}

.mbr-venue__back:active {
  transform: scale(0.95);
}

.mbr-venue__back svg {
  width: 16px;
  height: 16px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-venue__title {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  font-family: var(--mbr-font-headline) !important;
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-strong);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mbr-venue__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* room for the fixed CTA bar */
  padding: 16px 20px 128px;
}

.mbr-venue__eyebrow {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

.mbr-venue__img {
  height: 160px;
  overflow: hidden;
  background: var(--mbr-color-ink-headline);
  border-radius: 12px;
}

.mbr-venue__img--hero {
  border-radius: 24px;
}

.mbr-venue__img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
}

.mbr-venue__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

/* type cards */
.mbr-venue__type {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 12px 14px;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  text-align: left;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.mbr-venue__type-name {
  max-width: 100%;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
  overflow-wrap: anywhere;
}

.mbr-venue__type-price {
  font-family: var(--mbr-font-headline) !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: var(--mbr-color-ink-strong);
}

.mbr-venue__type--on {
  background: var(--mbr-color-primary);
  border-color: var(--mbr-color-primary);
}

.mbr-venue__type--on .mbr-venue__type-name {
  color: rgba(var(--mbr-color-surface-rgb), 0.8);
}

.mbr-venue__type--on .mbr-venue__type-price {
  color: var(--mbr-color-on-primary);
}

/* MBR067 date picker */
.mbr-venue__date {
  padding: 12px;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.6);
  border-radius: 24px;
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
}

.mbr-venue__date :deep(.dp__theme_light) {
  --dp-primary-color: var(--mbr-color-primary);
  --dp-primary-text-color: var(--mbr-color-on-primary);
  --dp-hover-color: var(--mbr-color-tint);
  --dp-border-color: var(--mbr-color-outline);
  --dp-border-color-hover: var(--mbr-color-primary);
  --dp-disabled-color-text: #c8b8b7;
  font-family: var(--mbr-font-body);
}

.mbr-venue__date :deep(.dp__input_wrap) {
  width: 100%;
}

.mbr-venue__date :deep(.dp__input) {
  height: 44px;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-body);
  font-size: 14px;
  font-weight: 600;
  color: var(--mbr-color-ink-strong);
}

.mbr-venue__date :deep(.dp__menu) {
  margin-top: 8px;
}

.mbr-venue__date :deep(.dp__calendar_header_item) {
  font-size: 11px;
  font-weight: 700;
  color: var(--mbr-color-ink-secondary);
}

.mbr-venue__date :deep(.dp__cell_inner) {
  border-radius: var(--mbr-radius-full);
  font-size: 13px;
  font-weight: 600;
}

.mbr-venue__date :deep(.dp__today) {
  border-color: var(--mbr-color-outline);
}

/* time slot chips */
.mbr-venue__slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 10px;
  background: var(--mbr-color-canvas);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
  transition: background 0.15s ease, border-color 0.15s ease;
}

.mbr-venue__slot:not(:disabled):hover {
  border-color: var(--mbr-color-primary);
}

.mbr-venue__slot--on {
  background: var(--mbr-color-primary);
  border-color: var(--mbr-color-primary);
  font-weight: 700;
  color: var(--mbr-color-on-primary);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.12);
}

.mbr-venue__slot--off {
  background: var(--mbr-color-tint);
  border-style: dashed;
  color: var(--mbr-color-ink-muted);
  opacity: 1;
}

.mbr-venue__slot-note {
  font-size: 10px;
  font-weight: 700;
  color: var(--mbr-color-error);
}

.mbr-venue__empty {
  padding: 24px;
  background: var(--mbr-color-card);
  border: 1px dashed var(--mbr-color-outline);
  border-radius: 24px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  color: var(--mbr-color-ink-secondary);
}

/* MBR066 terms step */
.mbr-venue__summary {
  padding: 20px;
  background: var(--mbr-color-primary);
  border-radius: 24px;
  box-shadow: 0 10px 15px -3px rgba(var(--mbr-color-primary-rgb), 0.2), 0 4px 6px -4px rgba(var(--mbr-color-primary-rgb), 0.2);
  color: var(--mbr-color-on-primary);
}

.mbr-venue__eyebrow--peach {
  color: var(--mbr-color-peach);
}

.mbr-venue__summary-date {
  margin: 0;
  font-family: var(--mbr-font-headline) !important;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: var(--mbr-color-on-primary);
}

.mbr-venue__summary-time {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: rgba(var(--mbr-color-surface-rgb), 0.85);
}

.mbr-venue__summary-time svg {
  width: 14px;
  height: 14px;
}

.mbr-venue__card {
  padding: 16px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.6);
  border-radius: 24px;
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
}

.mbr-venue__terms {
  margin-top: 12px;
  font-size: 13px;
  line-height: 20px;
  color: var(--mbr-color-ink-secondary);
}

/* merchant HTML: global rules resize <p> */
.mbr-venue__terms :deep(p) {
  margin: 0 0 8px;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

/* MBR067 sticky CTA */
.mbr-venue__ctabar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-venue__ctabar-inner {
  max-width: 440px;
  margin: 0 auto;
  padding: 12px 20px calc(24px + env(safe-area-inset-bottom));
}

.mbr-venue__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 56px;
  border: 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-primary);
  box-shadow: 0 8px 20px -4px rgba(var(--mbr-color-primary-rgb), 0.35);
  font-family: var(--mbr-font-headline) !important;
  font-size: 14px;
  font-weight: 700;
  color: var(--mbr-color-on-primary);
  transition: transform 0.15s ease, background-color 0.15s ease;
}

.mbr-venue__cta:not(:disabled):active {
  transform: scale(0.98);
}

.mbr-venue__cta:disabled {
  background: var(--mbr-color-outline);
  box-shadow: none;
  color: var(--mbr-color-on-primary);
}

.mbr-venue__cta svg {
  width: 16px;
  height: 16px;
}

.mbr-venue__back:focus-visible,
.mbr-venue__type:focus-visible,
.mbr-venue__slot:focus-visible,
.mbr-venue__cta:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}
</style>
